<template>
  <pf-title v-if="domain" h="3" class="pf-v6-u-mt-lg pf-v6-u-mt-md">{{ $t('Servizi associati al dominio {0}', [domain]) }}</pf-title>
  <pf-title v-else h="3" class="pf-v6-u-mt-lg pf-v6-u-mt-md">{{ $t('Altri servizi') }}</pf-title>

  <pf-table compact striped>
    <pf-thead>
      <pf-tr>
        <pf-th>{{ $t('Codice') }}</pf-th>
        <pf-th>{{ $t('Descrizione') }}</pf-th>
        <pf-th class="pf-v6-u-text-align-end">{{ $t('Listino') }}</pf-th>
        <pf-th class="pf-v6-u-text-align-end">{{ $t('Sconto') }}</pf-th>
        <pf-th class="pf-v6-u-text-align-end">{{ $t('Importo') }}</pf-th>
      </pf-tr>
    </pf-thead>
    <pf-tbody>
      <pf-tr
        v-for="prodotto in products"
        :key="prodotto.id"
        :class="{ 'striked': prodotto.disdire }"
      >
        <pf-td :data-label="$t('Codice')">{{ prodotto.codice }}</pf-td>
        <pf-td :data-label="$t('Descrizione')" class="text-preline">
          <template v-if="prodotto.qt != 1">{{ prodotto.qt }} x </template>
          {{ prodotto.descrizione }}
        </pf-td>
        <pf-td :data-label="$t('Listino')" class="pf-v6-u-text-align-end">{{ $currency(prodotto.importo, currency) }}</pf-td>
        <pf-td :data-label="$t('Sconto')" class="pf-v6-u-text-align-end">{{ $currency(prodotto.sconto) }} %</pf-td>
        <pf-td :data-label="$t('Importo')" class="pf-v6-u-text-align-end" >{{ $currency(prodotto.imponibile, currency) }}</pf-td>
      </pf-tr>
      <template v-if="domain && !hideSubtotal">
        <pf-tr v-if="importoTotaleAnnuale > 0">
          <pf-td colspan="4" class="pf-v6-u-text-align-end">
            <strong>{{ $t('Importo parziale annuale gruppo:') }}</strong>
          </pf-td>
          <pf-td class="pf-v6-u-text-align-end">
            <strong>{{ $currency(importoTotaleAnnuale, currency) }}</strong>
          </pf-td>
        </pf-tr>
        <pf-tr v-if="importoTotaleMensile > 0">
          <pf-td colspan="4" class="pf-v6-u-text-align-end">
            <strong>{{ $t('Importo parziale mensile gruppo:') }}</strong>
          </pf-td>
          <pf-td class="pf-v6-u-text-align-end">
            <strong>{{ $currency(importoTotaleMensile, currency) }}</strong>
          </pf-td>
        </pf-tr>
        <pf-tr v-if="importoTotaleUnatantum > 0">
          <pf-td colspan="4" class="pf-v6-u-text-align-end">
            <strong>{{ $t('Importo parziale una tantum gruppo:') }}</strong>
          </pf-td>
          <pf-td class="pf-v6-u-text-align-end">
            <strong>{{ $currency(importoTotaleUnatantum, currency) }}</strong>
          </pf-td>
        </pf-tr>
      </template>
    </pf-tbody>
  </pf-table>
</template>

<style scoped>
.striked {
  text-decoration: line-through;
}
.text-preline {
  white-space: pre-line;
}
</style>

<script lang="ts" setup>
import { computed } from 'vue';
import type { OfferProductDetail } from '@/resources';

const props = defineProps<{
  products: OfferProductDetail[],
  domain?: string,
  currency: 'CHF'|'EUR',
  hideSubtotal?: boolean,
}>();

const importoTotaleAnnuale = computed(() => props.products.reduce((sum, product) => sum + (product.durata === 'Annuale' ? product.imponibile : 0), 0));
const importoTotaleMensile = computed(() => props.products.reduce((sum, product) => sum + (product.durata === 'Mensile' ? product.imponibile : 0), 0));
const importoTotaleUnatantum = computed(() => props.products.reduce((sum, product) => sum + (product.durata === 'Una tantum' ? product.imponibile : 0), 0));
</script>
